import { AbstractControl, FormGroup } from "@angular/forms";
export function confirmPasswordValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    var control = formGroup.controls[controlName];
    var matchingControl = formGroup.controls[matchingControlName]


    if (matchingControl.errors && !matchingControl.errors["confirmPasswordValidator"]) {
      return;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmPasswordValidator: true });
    }

    else {
      matchingControl.setErrors(null);
    }
  };
}
